/* tslint:disable */
/* eslint-disable */
/**
 * FreightSimple Public API
 * API that powers FreightSimple\'s SPA
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface BookShipmentRequest
 */
export interface BookShipmentRequest {
    /**
     * 
     * @type {string}
     * @memberof BookShipmentRequest
     */
    shipmentId: string;
}

/**
 * Check if a given object implements the BookShipmentRequest interface.
 */
export function instanceOfBookShipmentRequest(value: object): value is BookShipmentRequest {
    if (!('shipmentId' in value) || value['shipmentId'] === undefined) return false;
    return true;
}

export function BookShipmentRequestFromJSON(json: any): BookShipmentRequest {
    return BookShipmentRequestFromJSONTyped(json, false);
}

export function BookShipmentRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): BookShipmentRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'shipmentId': json['shipmentId'],
    };
}

  export function BookShipmentRequestToJSON(json: any): BookShipmentRequest {
      return BookShipmentRequestToJSONTyped(json, false);
  }

  export function BookShipmentRequestToJSONTyped(value?: BookShipmentRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'shipmentId': value['shipmentId'],
    };
}

